import { urlWithQuery } from '~/utils/url';
import { BaseRestRepository } from './baseRestRepository';

const FEATURE_HIGHLIGHTS_URL = '/api/feature-highlights';

export interface FeatureHighlightDto {
  id: string;
  path: string;
  title: string;
  description: string;
  startDate: string;
}

export interface FeatureHighlightsDto {
  items: FeatureHighlightDto[];
}

class FeatureHighlightsRepository extends BaseRestRepository {
  public async getActiveFeatureHighlights(language: string): Promise<FeatureHighlightsDto> {
    const response = await this.fetchWithAuth(urlWithQuery(FEATURE_HIGHLIGHTS_URL, { language }));
    return this.getJsonResponse(response);
  }
}

export const featureHighlightsRepo = new FeatureHighlightsRepository();
